<template>
  <div class="custom-select-container">
    <div class="custom-select" @click="toggleSelect">
      <div class="select-selected">{{ selectedOption.name }}</div>
      <ul v-show="isOpen" class="select-items">
        <li
          v-for="option in options"
          :key="option.amt"
          @click.stop="selectOption(option)"
        >
          {{ option.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from 'vue'

export default {
  name: 'CustomSelect',
  props: {
    options: {
      type: Array,
      required: true,
    },
    defaultOption: {
      type: String,
      default: 'Select an option',
    },
  },
  emits: ['update:selected'],
  setup(props, { emit }) {
    const isOpen = ref(false)
    // const selectedOption = ref(props.defaultOption)
    const selectedOption = ref({
      name: props.defaultOption,
      amt: null,
    })

    const closeSelect = () => {
      isOpen.value = false
      document.removeEventListener('click', closeSelect)
    }

    const toggleSelect = (event) => {
      event.stopPropagation()
      isOpen.value = !isOpen.value
      if (isOpen.value) {
        const selectitems = document.querySelectorAll('.select-items')
        // console.log(selectitems)
        // console.log(selectitems.length)
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < selectitems.length; i++) {
          document.querySelectorAll('.select-items')[i].style.display = 'none'
        }
        document.addEventListener('click', closeSelect)
      } else {
        isOpen.value = false
        document.removeEventListener('click', closeSelect)
      }
    }

    const selectOption = (option) => {
      // console.log('option의 데이터 값', option)
      // console.log('option의 이름', option.name)
      // console.log('option의 가격', option.amt)
      selectedOption.value = option
      isOpen.value = false // ul 목록을 닫기 위해 isOpen을 false로 설정
      emit('update:selected', option) // 부모 컴포넌트에 선택된 값 전달
      document.removeEventListener('click', closeSelect)
    }
    onMounted(() => {
      document.addEventListener('click', closeSelect)
    })

    onBeforeUnmount(() => {
      document.removeEventListener('click', closeSelect)
    })

    return {
      isOpen,
      selectedOption,
      toggleSelect,
      selectOption,
    }
  },
}
</script>
